
'use client';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useRouter } from 'next/navigation';
import { Lock } from 'lucide-react';

interface PublicSignupDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  message?: string;
}

export function PublicSignUpDialog({
    open,
    onOpenChange,
    message,
  }: PublicSignupDialogProps) {
    const router = useRouter();
  
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <div className="mx-auto bg-[#b8b0ad] rounded-full p-3 w-16 h-16 flex items-center justify-center mb-2">
              <Lock className="w-8 h-8 text-black" />
            </div>
            <DialogTitle className="text-center text-2xl">
              Join Our Community
            </DialogTitle>
            <DialogDescription className="text-center text-gray-600 pt-2">
              {message ||
                'Create an account to see full posts, like, comment, and connect with neighbors!'}
            </DialogDescription>
          </DialogHeader>
  
          <div className="flex flex-col gap-2">
            <Button
              type="button"
              className="w-full h-10 border-0 rounded-full text-center text-[18px] font-black transition-all duration-200 bg-[#948780] cursor-pointer hover:bg-[#7a6b64]"
              onClick={() => {
                router.push('/signup');
                onOpenChange(false); 
              }}
            >
              Sign Up
            </Button>
            <Button
              variant="ghost"
              onClick={() => onOpenChange(false)} 
              className="text-gray-500 hover:text-gray-700"
            >
              Continue Preview
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    );
  }